import { Container, Typography, Box } from '@mui/material';

function Contact() {
  return (
    <Container>
      <Box sx={{ mt: 4 }}>
        <Typography variant="h3" gutterBottom>
          联系方式
        </Typography>
        <Typography variant="body1" paragraph>
          这里放置你的联系方式
        </Typography>
      </Box>
    </Container>
  );
}

export default Contact;